import Add16 from '@carbon/icons-react/es/add/16';
import SubtractAlt16 from '@carbon/icons-react/es/subtract--alt/16';
import { Col, Row, Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ReactComponent as RowConnectorSvg } from 'assets/svgs/row-connector.svg';
import { Button } from 'components/atoms/button';
import { Form } from 'components/atoms/form';
import { Input } from 'components/atoms/input';
import {
  DueDateFormItem,
  PrefixFormItem,
  SourceFormItem,
  StartDateFormItem,
} from './form-items';

const ConnectorWrapper = styled.div`
  margin-bottom: var(--layout-01);
  &:last-of-type {
    display: none;
  }
`;

const StyledRow = styled(Row)`
  ${Input}:first-of-type {
    border-right: 1px solid var(--gray-50);
  }
`;

export const StepOne: FC = () => (
  <Form.List name="sources">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <>
            <Row gutter={16} wrap={false} key={field.name}>
              <Col span={12}>
                <StyledRow gutter={0} wrap={false}>
                  <Col flex="120px">
                    <PrefixFormItem field={field} />
                  </Col>
                  <Col flex="auto">
                    <SourceFormItem field={field} />
                  </Col>
                </StyledRow>
              </Col>
              <Col span={12}>
                <Row gutter={16}>
                  <Col span={12}>
                    <StartDateFormItem field={field} />
                  </Col>
                  <Col>
                    <DueDateFormItem
                      startDateFieldNamePath={[
                        'sources',
                        field.name,
                        'startDate',
                      ]}
                      sourceFieldNamePath={['sources', field.name, 'source']}
                    />
                  </Col>
                  <Col>
                    <Form.Item label=" ">
                      <Tooltip title={<FormattedMessage id="remove" />}>
                        <Button
                          type="text"
                          icon={<SubtractAlt16 />}
                          onClick={() => remove(field.name)}
                        />
                      </Tooltip>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <ConnectorWrapper key={field.name}>
              <RowConnectorSvg />
            </ConnectorWrapper>
          </>
        ))}
        <Button
          type="link"
          iconPlacement="right"
          icon={<Add16 />}
          onClick={() => add()}
        >
          <FormattedMessage id="projects.phase.import.add_another" />
        </Button>
      </>
    )}
  </Form.List>
);
